import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {SvgIconEl} from 'common/components/svg-icon';
import {TooltipAttrs} from 'common/components/tooltip/types';

import type {QueryEntrySection} from '../index';
import {Entry} from '../types';

export function RowLabel({
  el,
  index,
  entry,
  isPlaceholder,
  reportName,
}: {
  el: QueryEntrySection;
  entry: Entry;
  index: number;
  isPlaceholder: boolean;
  reportName: string;
}) {
  const isClickable = !isPlaceholder && el.attr(`row-index-toggleable`);
  const prefix = el.attr(`row-label-prefix`);
  const hasPrefix = Boolean(prefix);
  const extraClass = {
    ...(reportName && {[`for-${reportName}`]: true, 'is-hidden': entry.isHidden}),
    ...(el.attr(`is-referenced-metrics`) && {'is-referenced-metrics': true}),
  };

  return (
    <>
      {/** optional prefixed grouped label */}
      {hasPrefix && (!el.hasNewQBUI() ? index === 0 : true) && (
        <RowLabelContent
          icon={el.attr(`row-label-prefix-icon`)}
          label={prefix}
          onClick={isClickable && el.helpers.onGroupEntryIndexLabelClicked.bind(el)}
          extraClass={{'is-prefix': true, ...extraClass}}
        />
      )}
      <RowLabelContent
        icon={el.helpers.getRowIcon(index)}
        label={el.helpers.getRowLabel(index)}
        onClick={isClickable && !hasPrefix && el.helpers.onEntryIndexLabelClicked.bind(el, index)}
        hasPrefix={hasPrefix}
        extraClass={extraClass}
      />
    </>
  );
}

function RowLabelContent({
  icon,
  label = null,
  onClick,
  hasPrefix = false,
  extraClass,
  tooltip = null,
}: {
  icon: string;
  label?: string;
  onClick?: (ev: MouseEvent) => void;
  hasPrefix?: boolean;
  extraClass?: Record<string, boolean>;
  tooltip?: TooltipAttrs;
}) {
  const isClickable = Boolean(onClick);
  const slotName = !isClickable && `selector-icon`;
  return (
    <div
      key={`entry-label-${slotName}-${icon}`}
      sel='.mp-query-entry-label'
      attrs={{elref: `rowLabel`, slot: !isClickable && `selector-icon`}}
    >
      {(label || icon) && (
        <ButtonEl
          attrs={{
            elref: `rowLabelButton`,
            theme: ButtonTheme.Tertiary,
            'not-focusable': !onClick,
            tooltip,
          }}
          class={{
            'is-clickable': isClickable,
            'has-prefix': hasPrefix,
            ...extraClass,
          }}
          on={{click: onClick}}
        >
          {icon ? <SvgIconEl attrs={{icon}} /> : <span>{label}</span>}
        </ButtonEl>
      )}
    </div>
  );
}
